export function userPageCutawayStatus(User: any) {
  switch (User?.cutaway?.status) {
    case 0:
      return {
        status: "btn--user-cutaway-disabled",
        text: "Визитка отправлена",
      };
    case 1:
      return {
        status: "btn--user-cutaway-disabled",
        text: "Визитка получена",
      };
    case 2:
      return {
        status: "btn--user-cutaway-rejected",
        text: "Визитка отклонена",
      }
    default:
      return {
        status: "btn--user-cutaway-enabled",
        text: "Отправить визитку",
      }
  }
}
